import {
  createContext,
  useContext,
  useState,
  FC,
  useEffect,
  ReactNode,
} from "react";

import { IAutoCompleted } from "../types/ProdutoresContext.Types";
import { UseAutoCompletedAll } from "../Utils/UseAutoCompletedAll";

import {
  IReportsConfirmationProducer,
  IReportsConfirmationPayment,
  IReportsProductionOperator,
  InputsConfirmationContract,
  InputsConfirmationPayment,
  IReportsProductionContract,
  IReportsProductionGerente,
  InputsConfirmationProducer,
  IReportsProductionProducer,
  IContextReportsProduction,
  InputsProductionContract,
  InputsProductionGerente,
  InputsProductionOperator,
  IReportsConfirmation,
  IReportsProductionSupervisor,
  InputsProductionSupervisor,
} from "./ReportsProductionTypes";
import {
  InputsDefaultReportsConfirmationContract,
  InputsDefaultReportsConfirmationPayment,
  InputsDefaultReportsConfirmationProducer,
  valuesDefaultInputsReportsGerente,
  valuesDefaultInputsReportsProduction,
  valuesDefaultInputsReportsOperator,
  valuesDefaultInputsReportsSupervisor,
} from "./ValuesDefaultInputsReportProduction/ValuesDefaultInputsReportProduction";

const RecibosContext = createContext({} as IContextReportsProduction);

export const ReportsProductionContextProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const {
    setValueAutoCompGerente,
    setValueAutoCompProdutorActive,
    setValueAutoCompSupervisor,
  } = UseAutoCompletedAll();

  const [valueAutoCompOperadoras, setValueAutoCompOperadoras] = useState<
    IAutoCompleted[]
  >([]);

  const [valueAutoCompAdministradoras, setValueAutoCompAdministradoras] =
    useState<IAutoCompleted[]>([]);

  const [valueAutoCompModalidades, setValueAutoCompModalidades] = useState<
    IAutoCompleted[]
  >([]);

  // PRODUÇÃO por contrato - START
  const [valuesInputsProductionContract, setValuesInputsProductionContract] =
    useState<InputsProductionContract>(valuesDefaultInputsReportsProduction);

  const [valuesInputsProductionOperator, setValuesInputsProductionOperator] =
    useState<InputsProductionOperator>(valuesDefaultInputsReportsOperator);

  const [listReportProductionContract, setListReportProductionContract] =
    useState<IReportsProductionContract>();

  const [listReportProductionProducer, setListReportProductionProducer] =
    useState<IReportsProductionProducer>();

  const [listReportProductionOperator, setListReportProductionOperator] =
    useState<IReportsProductionOperator>();

  // PRODUÇÃO por contrato - END

  // CONFIRMAÇÃO por contrato - START
  const [listReportConfirmationContract, setListReportConfirmationContract] =
    useState<IReportsConfirmation>();

  const [inputsConfirmationContract, setInputsConfirmationContract] =
    useState<InputsConfirmationContract>(
      InputsDefaultReportsConfirmationContract
    );
  // CONFIRMAÇÃO por contrato - END

  // CONFIRMAÇÃO por produtor - START
  const [listReportConfirmationProducer, setListReportConfirmationProducer] =
    useState<IReportsConfirmationProducer>();

  const [inputsConfirmationProducer, setInputsConfirmationProducer] =
    useState<InputsConfirmationProducer>(
      InputsDefaultReportsConfirmationProducer
    );
  // CONFIRMAÇÃO por produtor - END

  // CONFIRMAÇÃO de pagamentos - START
  const [listReportConfirmationPayment, setListReportConfirmationPayment] =
    useState<IReportsConfirmationPayment>();

  const [inputsConfirmationPayment, setInputsConfirmationPayment] =
    useState<InputsConfirmationPayment>(
      InputsDefaultReportsConfirmationPayment
    );
  // CONFIRMAÇÃO de pagamentos - END

  // PRODUÇÃO por supervisor - START
  const [listReportProductionSupervisor, setListReportProductionSupervisor] =
    useState<IReportsProductionSupervisor | undefined>(undefined);
  const [valuesInputsProductionSupervisor, setValuesInputsProductionSupervisor] =
    useState<InputsProductionSupervisor>(valuesDefaultInputsReportsSupervisor);
  // PRODUÇÃO por supervisor - END

  // PRODUÇÃO por gerente - START
  const [listReportProductionGerente, setListReportProductionGerente] =
    useState<IReportsProductionGerente | undefined>(undefined);
  const [valuesInputsProductionGerente, setValuesInputsProductionGerente] =
    useState<InputsProductionGerente>(valuesDefaultInputsReportsGerente);
  // PRODUÇÃO por gerente - END

  useEffect(() => {
    setValueAutoCompProdutorActive({ id: "", label: "" });
  }, [valuesInputsProductionContract.type_report]);

  useEffect(() => {
    setValueAutoCompProdutorActive({ id: "", label: "" });
  }, [inputsConfirmationContract.type_report]);

  useEffect(() => {
    setValueAutoCompSupervisor({ id: "", label: "" });
  }, [valuesInputsProductionSupervisor.type_report]);

  useEffect(() => {
    setValueAutoCompGerente({ id: "", label: "" });
  }, [valuesInputsProductionGerente.type_report]);

  useEffect(() => {
    setValueAutoCompProdutorActive({ id: "", label: "" });
    setValueAutoCompSupervisor({ id: "", label: "" });
    setValueAutoCompGerente({ id: "", label: "" });
  }, [
    inputsConfirmationPayment.funcao_produtor,
    inputsConfirmationPayment.type_report,
  ]);

  return (
    <RecibosContext.Provider
      value={{
        setListReportConfirmationProducer,
        setListReportConfirmationPayment,
        setListReportConfirmationContract,
        setValuesInputsProductionContract,
        setValuesInputsProductionSupervisor,
        setValuesInputsProductionGerente,
        setValuesInputsProductionOperator,
        setValueAutoCompAdministradoras,
        setListReportProductionContract,
        setListReportProductionProducer,
        setListReportProductionOperator,
        setListReportProductionSupervisor,
        setListReportProductionGerente,
        listReportProductionGerente,
        valuesInputsProductionGerente,
        listReportProductionSupervisor,
        valuesInputsProductionSupervisor,
        valuesInputsProductionOperator,
        listReportConfirmationProducer,
        listReportConfirmationPayment,
        listReportConfirmationContract,
        valuesInputsProductionContract,
        setInputsConfirmationContract,
        setInputsConfirmationProducer,
        setInputsConfirmationPayment,
        listReportProductionOperator,
        listReportProductionContract,
        listReportProductionProducer,
        valueAutoCompAdministradoras,
        setValueAutoCompModalidades,
        inputsConfirmationProducer,
        inputsConfirmationPayment,
        inputsConfirmationContract,
        setValueAutoCompOperadoras,
        valueAutoCompModalidades,
        valueAutoCompOperadoras,
      }}
    >
      {children}
    </RecibosContext.Provider>
  );
};

export const useContextReportsProduction = (): IContextReportsProduction =>
  useContext(RecibosContext);
